import { render, staticRenderFns } from "./header_new.vue?vue&type=template&id=a5bb254a&scoped=true&"
import script from "./header_new.vue?vue&type=script&lang=js&"
export * from "./header_new.vue?vue&type=script&lang=js&"
import style0 from "./header_new.vue?vue&type=style&index=0&id=a5bb254a&lang=stylus&scoped=true&"
import style1 from "./header_new.vue?vue&type=style&index=1&id=a5bb254a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bb254a",
  null
  
)

export default component.exports